var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSavedIcon = function SvgSavedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 14.52a6.02 6.02 0 100-12.04 6.02 6.02 0 000 12.04zm0 1.063a7.083 7.083 0 100-14.166 7.083 7.083 0 000 14.166z",
    fill: "#247534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.097 6.54a.75.75 0 01.084.997l-2.724 3.542a.638.638 0 01-.473.254.627.627 0 01-.492-.207L5.858 9.355a.75.75 0 010-1.002.619.619 0 01.924 0l1.129 1.223 2.266-2.946a.62.62 0 01.92-.09z",
    fill: "#247534"
  })));
};
export default SvgSavedIcon;